import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { fetchAPI, getStrapiMedia } from '../../utils/api';

const Experiences = () => {
  const [experiences, setExperiences] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const getData = async () => {
      try {
        // Fetch teams data. Assuming endpoint is /teams based on user request.
        // If /teams fails, we might need to check the actual endpoint name (e.g., /authors or /team-members).
        const response = await fetchAPI('/teams', {
          populate: '*'
        });

        if (response.data) {
          setExperiences(response.data);
        }
      } catch (error) {
        console.error("Error fetching teams data:", error);
      } finally {
        setLoading(false);
      }
    };

    getData();
  }, []);

  if (loading) return null; // Or a loading spinner

  return (
    <section className="experiences sticky primary-bg">
      <div className="container">
        <div className="row justify-content-between">
          <div className="col-12 col-lg-3">
            {/* Intro */}
            <div className="intro">
              <h3 className="title">Leadership</h3>
            </div>
          </div>

          <div className="col-12 col-lg-8">
            <div className="row items">
              {experiences.map((experience, index) => (
                <div key={experience.id || index} className="col-12 col-md-6 item">
                  <div className="content">
                    <span className="count">
                      {(index + 1) < 10 ? `0${index + 1}.` : `${index + 1}.`}
                    </span>
                    <Link to={`/leadership/${experience.documentId || experience.id}`}>
                      {/*<div className="image-container mb-3" style={{ height: '200px', overflow: 'hidden', borderRadius: '8px' }}>
                        {experience.Image || experience.image ? (
                          <img
                            src={getStrapiMedia(experience.Image || experience.image)}
                            alt={experience.Name || experience.name}
                            style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                          />
                        ) : (
                          <div style={{ width: '100%', height: '100%', backgroundColor: '#eee', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                            <span>No Image</span>
                          </div>
                        )}
                      </div>*/}
                      <h4 className="title mt-0 mb-3">{experience.Name || experience.name}</h4>
                    </Link>
                    {/* Display Role if available, else just render Bio */}
                    {experience.Role && <h6 className="position my-3">{experience.Role}</h6>}
                    {experience.role && <h6 className="position my-3">{experience.role}</h6>}

                    <p style={{ display: '-webkit-box', WebkitLineClamp: 3, WebkitBoxOrient: 'vertical', overflow: 'hidden' }}>
                      {experience.Bio || experience.bio || experience.description}
                    </p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Experiences;
